module.exports = __webpack_public_path__ + "static/media/Portrait-10255.d3996556.jpg";